import React from 'react';
import { Avatar, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  avatarColor: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.primary.main,
    filter: 'brightness(65%)',
    zIndex: 1
  },
  avatarTypography: {
    fontSize: 18,
    zIndex: 2
  }
}));

const DarkenAvatar = ({ className, children, ...other }) => {
  const classes = useStyles();

  return (
    <Avatar className={clsx(className)} {...other}>
      <div className={classes.avatarColor} />
      <Typography className={classes.avatarTypography}>{children}</Typography>
    </Avatar>
  );
};

export default DarkenAvatar;
